import { Container, IAppState } from "app/containers/Container";
import * as React from "react";
import { ContactUs, CopyrightFooter } from "app/components";
import { Row, Col, Panel, Tab, Nav, NavItem } from "react-bootstrap";
import {
  getAssetLevels,
  ISelect,
  getIntroductionText,
} from "app/components/visualizations/PeerGroups/lib/http";
import { Overview } from "app/components/visualizations/PeerGroups/Overview";
import { OperatingExpense } from "./tabs/OperatingExpense";
import { Other } from "./tabs/Other";
import { IncomingContributions } from "./tabs/IncomingContributions";
import { Giving } from "./tabs/Giving";
import { AssetAllocation } from "./tabs/AssetAllocation";
import { InvestmentExpense } from "./tabs/InvestmentExpense";
import { TabHeader } from "app/components/tabs/header";
import { Performance } from "./tabs/Performance";

interface IPeerGroupsState {
  assetLevel: number;
  assetLevels: ISelect[];
  assetName: string;
  descriptionText: string;
}

export class PeerGroups extends Container<{}, IPeerGroupsState> {
  mapAppStateToContainerState(appState: IAppState): IPeerGroupsState {
    return {
      assetLevel: 0,
      assetLevels: [],
      assetName: "",
      descriptionText: "",
    };
  }

  tabs = [
    {
      key: "description",
      label: "Peer Group Overview",
    },
    {
      key: "performance",
      label: "Investment Performance",
    },
    {
      key: "investmentexpenses",
      label: "Investment Expenses",
    },
    {
      key: "giving",
      label: "Giving",
    },
    {
      key: "allocation",
      label: "Strategy / Allocation",
    },
    {
      key: "operatingexpenses",
      label: "Operating Expenses",
    },
    {
      key: "contributions",
      label: "Incoming Contributions",
    },
    {
      key: "other",
      label: "Trustees / Other",
    },
  ];

  componentDidMount() {
    getAssetLevels().then((response) => {
      this.setState({ assetLevels: response });
    });

    //this.loadIntroductionText()
  }

  updateAssetLevel(id: number) {
    const assetLevel = this.state.assetLevels.find((value) => value.id == id);
    const assetName = assetLevel.asset_level;
    this.setState({ assetLevel: id, assetName }, () =>
      this.loadIntroductionText()
    );
  }

  updateAssetLevelByName(asset_level: string) {
    const assetLevel = this.state.assetLevels.find(
      (value) => value.asset_level == asset_level
    );
    const assetName = assetLevel ? assetLevel.asset_level : "";
    this.setState({ assetLevel: assetLevel.id, assetName });
  }

  renderCheck(shouldBeChecked: boolean) {
    return shouldBeChecked ? (
      <i
        className="fa fa-check text-success"
        style={{ fontSize: "2.0rem" }}
      ></i>
    ) : null;
  }

  loadIntroductionText() {
    getIntroductionText(this.state.assetLevel).then((response) => {
      this.setState({
        descriptionText:
          response && response.data && response.data.length > 0
            ? response.data[0].intro_text_one
            : "",
      });
    });
  }

  renderButtonClasses() {
    return "list-group-item list-group-item-action";
  }

  renderTabPill(tab) {
    return (
      <Col sm={12} md={3} key={tab.key}>
        <Nav bsStyle="pills" stacked>
          <NavItem
            eventKey={tab.key}
            style={{
              textAlign: "center",
              backgroundColor: "#D9E1F2",
              color: "#fff",
              marginTop: "5px",
            }}
          >
            {tab.label}
          </NavItem>
        </Nav>
      </Col>
    );
  }

  render() {
    const { assetLevel, assetLevels, assetName } = this.state;
    return (
      <section>
        <section
          className="container margin-bottom"
          style={{ overflowX: "hidden" }}
        >
          <section className="animated fadeInRight">
            <Panel>
              <Row>
                <Col sm={12}>
                  <div className="panel-body">
                    <Row>
                      <Col sm={12} md={4}>
                        <h3 className="hidden-xs">Select Asset Level</h3>
                        <h4 className="visible-xs">Select Asset Level</h4>
                      </Col>
                      <Col sm={12} md={8}>
                        <div
                          style={{
                            marginTop: "2.5rem",
                            marginBottom: "1.5rem",
                          }}
                        >
                          <select
                            id="assetLevelSelect"
                            style={{
                              padding: "10px",
                              border: "1px solid grey",
                            }}
                            value={assetLevel}
                            onChange={(e) =>
                              this.updateAssetLevel(
                                parseInt(e.currentTarget.value)
                              )
                            }
                          >
                            {assetLevels &&
                              assetLevels.map((value, index) => {
                                return (
                                  <option
                                    key={value.asset_level + value.id + index}
                                    value={value.id}
                                  >
                                    {value.asset_level}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey="description"
              >
                <section>
                  <Row className="clearfix" style={{ padding: "10px" }}>
                    {this.tabs.map((tab) => {
                      return this.renderTabPill(tab);
                    })}
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <Tab.Content animation>
                        <Tab.Pane
                          eventKey="description"
                          style={{
                            border: "1px solid #1f5b8f",
                            borderRadius: "3px",
                            padding: "5px",
                            minHeight: "605px",
                          }}
                        >
                          <TabHeader
                            filters={{ assetLevel, assetName }}
                            label="Overview"
                          />
                          <Overview
                            filters={{ assetLevel, assetName }}
                            onChange={(category) =>
                              this.updateAssetLevelByName(category)
                            }
                          />
                        </Tab.Pane>
                        <Tab.Pane
                          eventKey="performance"
                          style={{
                            border: "1px solid #1f5b8f",
                            borderRadius: "3px",
                            padding: "5px",
                            minHeight: "605px",
                          }}
                        >
                          <Performance filters={{ assetName, assetLevel }} />
                        </Tab.Pane>
                        <Tab.Pane
                          eventKey="investmentexpenses"
                          style={{
                            border: "1px solid #1f5b8f",
                            borderRadius: "3px",
                            padding: "5px",
                            minHeight: "605px",
                          }}
                        >
                          <InvestmentExpense
                            filters={{ assetLevel, assetName }}
                            onChange={(category) =>
                              this.updateAssetLevelByName(category)
                            }
                            onChangeFilterId={(filterId) =>
                              this.updateAssetLevel(filterId)
                            }
                          />
                        </Tab.Pane>
                        <Tab.Pane
                          eventKey="contributions"
                          style={{
                            border: "1px solid #1f5b8f",
                            borderRadius: "3px",
                            padding: "5px",
                            minHeight: "605px",
                          }}
                        >
                          <IncomingContributions
                            filters={{ assetLevel, assetName }}
                            onChangeFilterId={(filterId) =>
                              this.updateAssetLevel(filterId)
                            }
                          />
                        </Tab.Pane>
                        <Tab.Pane
                          eventKey="other"
                          style={{
                            border: "1px solid #1f5b8f",
                            borderRadius: "3px",
                            padding: "5px",
                            minHeight: "605px",
                          }}
                        >
                          <Other filters={{ assetLevel, assetName }} />
                        </Tab.Pane>
                        <Tab.Pane
                          eventKey="giving"
                          style={{
                            border: "1px solid #1f5b8f",
                            borderRadius: "3px",
                            padding: "5px",
                            minHeight: "605px",
                          }}
                        >
                          <Giving filters={{ assetLevel, assetName }} />
                        </Tab.Pane>
                        <Tab.Pane
                          eventKey="operatingexpenses"
                          style={{
                            border: "1px solid #1f5b8f",
                            borderRadius: "3px",
                            padding: "5px",
                            minHeight: "605px",
                          }}
                        >
                          <OperatingExpense
                            filters={{ assetLevel, assetName }}
                          />
                        </Tab.Pane>
                        <Tab.Pane
                          eventKey="allocation"
                          style={{
                            border: "1px solid #1f5b8f",
                            borderRadius: "3px",
                            padding: "5px",
                            minHeight: "605px",
                          }}
                        >
                          <AssetAllocation
                            filters={{ assetLevel, assetName }}
                          />
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </section>
              </Tab.Container>
            </Panel>
          </section>
        </section>
        <footer className="margin-y-xl">
          <ContactUs />
          <CopyrightFooter />
        </footer>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/PeerGroups/index.tsx